import { defineStore } from 'pinia'
import { ref } from 'vue'
import clientTypesAPI from '@/api/clientTypes'

export const useClientTypeStore = defineStore('clientTypes', () => {
  const client_types = ref<any[]>([])

  const fetchClientTypes = async (filters: any = {}) => {
    try {
      const response = await clientTypesAPI.getClientTypes(filters)
      client_types.value = response.data?.data || response.data || []
    } catch (error) {
      console.error('Error fetching client types:', error)
    }
  }

  const createClientType = async (clientTypeData: any) => {
    try {
      const response = await clientTypesAPI.createClientType(clientTypeData)
      await fetchClientTypes()
      return response.data
    } catch (error) {
      console.error('Error creating client type:', error)
      throw error
    }
  }

  const updateClientType = async (id: number, clientTypeData: any) => {
    try {
      const response = await clientTypesAPI.updateClientType(id, clientTypeData)
      await fetchClientTypes()
      return response.data
    } catch (error) {
      console.error('Error updating client type:', error)
      throw error
    }
  }

  const deleteClientType = async (id: number) => {
    try {
      const response = await clientTypesAPI.deleteClientType(id)
      await fetchClientTypes()
      return response.data
    } catch (error) {
      console.error('Error deleting client type:', error)
      throw error
    }
  }

  return {
    client_types,
    fetchClientTypes,
    createClientType,
    updateClientType,
    deleteClientType,
  }
})
